import {queryOptions} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';
import type {Action} from '../type/action';

interface ActionsListResponse {
  items: Action[];
  total: number;
  page: number;
}

export interface ActionsListOptionsProps {
  sortOrder?: 'asc' | 'desc';
  sortBy?: 'coinsPrice';
  limit?: number;
  page?: number;
  price?: [number, number];
  isActive?: boolean;
  userId?: number;
  celebrityId?: number[];
  type?: string;
  celebrityName?: string;
}

export const actionsListOptions = ({
  sortOrder,
  sortBy,
  isActive,
  userId,
  price,
  celebrityId,
  type,
  limit,
  page,
  celebrityName,
}: ActionsListOptionsProps) =>
  queryOptions({
    queryKey: [
      'actions-list',
      sortOrder,
      sortBy,
      isActive,
      userId,
      // нормализуем массив, чтобы ключ был стабильным
      Array.isArray(celebrityId) ? celebrityId.join(',') : celebrityId,
      type,
      limit,
      page,
      price,
      celebrityName,
    ],
    queryFn: async () => {
      try {
        // Сериализация параметров вручную
        const params = new URLSearchParams();

        if (sortOrder) params.set('sortOrder', sortOrder);
        if (sortBy) params.set('sortBy', sortBy);
        if (typeof isActive === 'boolean') params.set('isActive', String(isActive));
        if (typeof userId === 'number') params.set('userId', String(userId));
        if (typeof limit === 'number') params.set('limit', String(limit));
        if (typeof page === 'number') params.set('page', String(page));
        if (type) params.set('type', type);
        if (price) {
          const [from, to] = price;
          params.set('coinsPriceFrom', from.toString());
          params.set('coinsPriceTo', to.toString());
        }
        if (celebrityName) params.set('celebrityName', celebrityName);
        if (Array.isArray(celebrityId)) {
          for (const id of celebrityId) {
            // ключ повторяется без []
            params.append('celebrityId', String(id));
          }
        }

        const response = await api.get<ActionsListResponse>('/actions', {
          params, // Axios корректно подставит URLSearchParams как есть
          paramsSerializer: p => (p as URLSearchParams).toString(),
        });

        return response.data;
      } catch (error) {
        console.error('Failed to fetch actions:', JSON.stringify(error));
        return {items: [], total: 0, page: 0};
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
